import React from "react";
import Popover from "./Popover";

export default (props) => {
  const style = props.style
    ? { ...props.style, marginLeft: "-1em" }
    : { marginLeft: "-1em" };

  return (
    <div style={style}>
      <div style={{ float: "left", marginLeft: "1em" }}>
        <span style={{ whiteSpace: "pre-wrap" }}>
          <b>Note: </b>Normal font indicates the data is saved as <b>date</b>{" "}
          <Popover />
          {"\n"}
          <span className="font-italic">Italic font</span> indicates the data is
          saved as <b>string</b>
        </span>
      </div>
      <div style={{ clear: "left" }}></div>
    </div>
  );
};
